/**
 * Wizard abonnement café — Cafés Van Hove
 * Inspiré du parcours incapto.com/en/pages/wizard
 * Vanilla JS, aucune dépendance externe.
 */
(function () {
  "use strict";

  var root = document.querySelector("[data-wizard]");
  if (!root) return;

  // Fill the whole page background so there's no white gutter beside the
  // centered wizard content on wide screens (fallback for browsers without :has()).
  document.documentElement.style.background = "#FAF8F4";
  document.body.style.background = "#FAF8F4";

  var dataEl = root.querySelector("[data-wizard-json]");
  var DATA = JSON.parse(dataEl.textContent);

  var TOTAL_STEPS = 6;

  var state = {
    step: 1,
    planType: null, // 'machine-coffee' | 'coffee-only'
    machine: null, // { product, variantId }
    frequency: null, // { id (plan name), label, adjustmentValue }
    coffees: {}, // productId -> { product, variantId, qty }
    accessories: {}, // productId -> { product, qty }
    cupsPerDay: 2,
    targetGrams: null,
    submitted: false,
  };

  function money(amountCents) {
    var value = (Number(amountCents) || 0) / 100;
    return value.toLocaleString("fr-BE", { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + " €";
  }

  // ---------- Frequency options (derived from the first coffee product that has selling plans) ----------
  function buildFrequencies() {
    var source = DATA.coffees.find(function (c) { return c.sellingPlans && c.sellingPlans.length; });
    if (!source) return [];
    return source.sellingPlans.map(function (plan) {
      return {
        name: plan.name,
        adjustmentValue: plan.adjustmentValue || 0,
        adjustmentType: plan.adjustmentType || "percentage",
      };
    });
  }
  var FREQUENCIES = buildFrequencies();

  function findSellingPlanForProduct(product, frequencyName) {
    if (!product.sellingPlans || !frequencyName) return null;
    var match = product.sellingPlans.find(function (p) { return p.name === frequencyName; });
    if (!match) {
      // Tolère les espaces en fin de nom de plan (ex. "Livraison toutes les 3 semaines ")
      var wanted = frequencyName.trim().toLowerCase();
      match = product.sellingPlans.find(function (p) { return (p.name || "").trim().toLowerCase() === wanted; });
    }
    return match || null;
  }

  // ---------- Rendering: grids ----------
  function renderProductGrid(gridEl, products, opts) {
    gridEl.innerHTML = "";
    if (!products.length) {
      var empty = document.createElement("p");
      empty.className = "wiz__empty";
      empty.textContent = "Aucun produit disponible pour le moment.";
      gridEl.appendChild(empty);
      return;
    }
    products.forEach(function (product) {
      gridEl.appendChild(opts.renderCard(product));
    });
  }

  function sortProducts(list, mode) {
    var copy = list.slice();
    if (mode === "price-asc") copy.sort(function (a, b) { return a.price - b.price; });
    else if (mode === "price-desc") copy.sort(function (a, b) { return b.price - a.price; });
    else if (mode === "az") copy.sort(function (a, b) { return a.title.localeCompare(b.title); });
    return copy;
  }

  // ---------- Step 2: machine ----------
  var machineGrid = root.querySelector('[data-grid="machines"]');
  function renderMachines(mode) {
    var list = sortProducts(DATA.machines, mode || "featured");
    renderProductGrid(machineGrid, list, {
      renderCard: function (product) {
        var selection = state.machine && state.machine.product.id === product.id ? state.machine : null;
        var hasOptions = (product.variants || []).length > 1;
        var selectedVariant = selection ? (product.variants || []).find(function (v) { return v.id === selection.variantId; }) : null;
        var card = document.createElement("div");
        card.className = "wiz__card";
        if (selection) card.classList.add("is-selected");
        var btnLabel = selection ? (hasOptions && selectedVariant ? "Modifier — " + selectedVariant.title : "Sélectionné ✓") : "Choisir";
        card.innerHTML =
          '<div class="wiz__card-media"><span class="wiz__badge wiz__badge--onetime">Achat unique</span><img src="' + product.image + '" alt="' + escapeHtml(product.title) + '" loading="lazy"></div>' +
          '<div class="wiz__card-body">' +
          '<h3 class="wiz__card-title">' + escapeHtml(product.title) + "</h3>" +
          '<p class="wiz__card-price">' + money(product.price) + "</p>" +
          '<button type="button" class="wiz__btn wiz__btn--select" data-open-machine-modal>' + escapeHtml(btnLabel) + "</button>" +
          "</div>";
        card.querySelector("[data-open-machine-modal]").addEventListener("click", function () {
          openMachineModal(product);
        });
        return card;
      },
    });
  }

  // ---------- Step 2: machine detail modal (choix des options, comme pour le café) ----------
  var machineOverlay = root.querySelector("[data-machine-overlay]");
  var machineModal = root.querySelector("[data-machine-modal]");
  var machineModalImageEl = root.querySelector("[data-machine-modal-image]");
  var machineModalTitleEl = root.querySelector("[data-machine-modal-title]");
  var machineModalTaglineEl = root.querySelector("[data-machine-modal-tagline]");
  var machineModalPriceEl = root.querySelector("[data-machine-modal-price]");
  var machineModalOptionsEl = root.querySelector("[data-machine-modal-options]");
  var machineModalSelectBtn = root.querySelector("[data-machine-modal-select]");
  var machineModalRemoveBtn = root.querySelector("[data-machine-modal-remove]");
  var machineModalCloseBtns = root.querySelectorAll("[data-machine-modal-close]");

  var machineModalState = null; // { product, variantId }

  function machineModalSelectedVariant() {
    if (!machineModalState) return null;
    var variants = machineModalState.product.variants || [];
    return variants.find(function (v) { return v.id === machineModalState.variantId; }) || variants[0];
  }

  function renderMachineModalOptions() {
    if (!machineModalOptionsEl) return;
    var product = machineModalState.product;
    var variants = product.variants || [];
    machineModalOptionsEl.innerHTML = "";
    if (variants.length <= 1) {
      machineModalOptionsEl.hidden = true;
      return;
    }
    machineModalOptionsEl.hidden = false;
    variants.forEach(function (variant) {
      var isSelected = machineModalState.variantId === variant.id;
      var row = document.createElement("div");
      row.className = "wiz__variant-row wiz__variant-row--option" + (isSelected ? " is-selected" : "");
      row.innerHTML =
        '<span class="wiz__variant-radio" aria-hidden="true"></span>' +
        '<span class="wiz__variant-weight">' + escapeHtml(variant.title) + "</span>" +
        '<span class="wiz__variant-price"><strong>' + money(variant.price) + "</strong></span>";
      row.addEventListener("click", function () {
        if (machineModalState.variantId === variant.id) return;
        machineModalState.variantId = variant.id;
        renderMachineModalOptions();
        renderMachineModalPrice();
      });
      machineModalOptionsEl.appendChild(row);
    });
  }

  function renderMachineModalPrice() {
    var variant = machineModalSelectedVariant();
    if (!variant) return;
    machineModalPriceEl.innerHTML = '<span class="current">' + money(variant.price) + "</span>";
  }

  function openMachineModal(product) {
    var existing = state.machine && state.machine.product.id === product.id ? state.machine : null;
    var initialVariantId = existing ? existing.variantId : (product.defaultVariantId || (product.variants[0] && product.variants[0].id));
    machineModalState = { product: product, variantId: initialVariantId };
    machineModalImageEl.src = product.image;
    machineModalImageEl.alt = product.title;
    machineModalTitleEl.textContent = product.title;
    machineModalTaglineEl.textContent = product.tagline || "";
    renderMachineModalOptions();
    renderMachineModalPrice();
    if (machineModalRemoveBtn) machineModalRemoveBtn.hidden = !existing;

    machineModal.hidden = false;
    machineModal.setAttribute("aria-hidden", "false");
    if (machineOverlay) machineOverlay.hidden = false;
    document.body.style.overflow = "hidden";
  }

  function closeMachineModal() {
    if (!machineModal) return;
    machineModal.hidden = true;
    machineModal.setAttribute("aria-hidden", "true");
    if (machineOverlay) machineOverlay.hidden = true;
    document.body.style.overflow = "";
    machineModalState = null;
  }

  machineModalCloseBtns.forEach(function (btn) { btn.addEventListener("click", closeMachineModal); });
  if (machineOverlay) machineOverlay.addEventListener("click", closeMachineModal);
  if (machineModalSelectBtn) {
    machineModalSelectBtn.addEventListener("click", function () {
      if (!machineModalState) return;
      state.machine = { product: machineModalState.product, variantId: machineModalState.variantId };
      renderMachines(currentSort("machines"));
      updateSummary();
      clearNavError();
      closeMachineModal();
    });
  }
  if (machineModalRemoveBtn) {
    machineModalRemoveBtn.addEventListener("click", function () {
      state.machine = null;
      renderMachines(currentSort("machines"));
      updateSummary();
      closeMachineModal();
    });
  }

  // ---------- Step 3: how much coffee per day ----------
  var qtyValueEl = root.querySelector("[data-qty-value]");
  var qtyHintEl = root.querySelector("[data-qty-hint]");
  var qtyDecBtn = root.querySelector("[data-qty-dec]");
  var qtyIncBtn = root.querySelector("[data-qty-inc]");
  var GRAMS_PER_CUP_PER_DAY = 8;

  function parseFrequencyDays(name) {
    var lower = (name || "").toLowerCase();
    var match = lower.match(/(\d+)/);
    var n = match ? parseInt(match[1], 10) : 1;
    if (lower.indexOf("semaine") !== -1) return n * 7;
    if (lower.indexOf("mois") !== -1) return n * 30;
    return 30;
  }

  function roundToHalfKg(grams) {
    return Math.max(500, Math.round(grams / 500) * 500);
  }

  function computeCardWeight(freqName) {
    var days = parseFrequencyDays(freqName);
    return roundToHalfKg(state.cupsPerDay * GRAMS_PER_CUP_PER_DAY * days);
  }

  function recomputeTarget() {
    if (!state.frequency) {
      state.targetGrams = null;
      return;
    }
    var days = parseFrequencyDays(state.frequency.name);
    var grams = state.cupsPerDay * GRAMS_PER_CUP_PER_DAY * days;
    state.targetGrams = roundToHalfKg(grams);
  }

  function renderQuantity() {
    if (!qtyValueEl) return;
    qtyValueEl.textContent = state.cupsPerDay;
    if (state.frequency) recomputeTarget();
    var monthlyGrams = roundToHalfKg(state.cupsPerDay * GRAMS_PER_CUP_PER_DAY * 30);
    qtyHintEl.textContent = formatGrams(monthlyGrams) + " / mois";
    renderWeightProgress();
    renderFrequencies();
  }
  if (qtyDecBtn) {
    qtyDecBtn.addEventListener("click", function () {
      state.cupsPerDay = Math.max(1, state.cupsPerDay - 1);
      renderQuantity();
    });
  }
  if (qtyIncBtn) {
    qtyIncBtn.addEventListener("click", function () {
      state.cupsPerDay = Math.min(600, state.cupsPerDay + 1);
      renderQuantity();
    });
  }

  // ---------- Step 3: frequency (2 cartes Mensuel / Trimestriel + autres rythmes en pastilles discrètes) ----------
  var freqGrid = root.querySelector('[data-grid="frequencies"]');
  var QUARTERLY_MIN_GRAMS = 1000; // La remise trimestrielle nécessite au moins 1 kg de café sélectionné
  var MAIN_FREQUENCY_NAMES = ["tous les mois", "tous les 3 mois"];
  var FREQ_ICON =
    '<svg viewBox="0 0 32 32" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">' +
    '<path d="M10 7c0-1.4 1.2-2.6 2.6-2.6h6.8c1.4 0 2.6 1.2 2.6 2.6l1.3 5.3v13.2A2.6 2.6 0 0 1 20.7 28h-9.4a2.6 2.6 0 0 1-2.6-2.6V12.3z"/>' +
    '<path d="M10 12.3h12"/></svg>';

  // Conteneur des fréquences secondaires (mêmes plans que sur la fiche produit), juste sous les 2 cartes
  var freqMoreEl = document.createElement("div");
  freqMoreEl.className = "wiz__freq-more";
  freqMoreEl.hidden = true;
  if (freqGrid && freqGrid.parentNode) freqGrid.parentNode.insertBefore(freqMoreEl, freqGrid.nextSibling);

  (function injectFreqMoreStyles() {
    if (document.getElementById("wiz-freq-more-styles")) return;
    var css =
      ".wiz .wiz__freq-more{margin:28px auto 0;max-width:680px;text-align:center}" +
      ".wiz .wiz__freq-more[hidden]{display:none}" +
      ".wiz .wiz__freq-more-label{margin:0 0 10px;font-size:13px;line-height:1.4;color:var(--wiz-primary,#3B2A1E);opacity:.7}" +
      ".wiz .wiz__freq-more-pills{display:flex;flex-wrap:wrap;justify-content:center;gap:8px}" +
      ".wiz button.wiz__freq-pill{-webkit-appearance:none;appearance:none;display:inline-flex;align-items:center;justify-content:center;width:auto!important;min-width:0!important;height:auto!important;min-height:0!important;margin:0;padding:7px 14px!important;border:1px solid rgba(59,42,30,.2);border-radius:999px;background:transparent;color:var(--wiz-primary,#3B2A1E);font:inherit;font-size:13px;font-weight:500;line-height:1.2;letter-spacing:normal;text-transform:none;box-shadow:none;cursor:pointer;transition:border-color .15s ease,background-color .15s ease,color .15s ease}" +
      ".wiz button.wiz__freq-pill:hover{border-color:var(--wiz-accent,#C08B3E)}" +
      ".wiz button.wiz__freq-pill:focus-visible{outline:2px solid var(--wiz-accent,#C08B3E);outline-offset:2px}" +
      ".wiz button.wiz__freq-pill.is-selected{background:var(--wiz-primary,#3B2A1E);border-color:var(--wiz-primary,#3B2A1E);color:#fff}" +
      ".wiz .wiz__freq-more-note{margin:10px 0 0;font-size:12px;line-height:1.4;color:var(--wiz-primary,#3B2A1E);opacity:.65}";
    var style = document.createElement("style");
    style.id = "wiz-freq-more-styles";
    style.textContent = css;
    document.head.appendChild(style);
  })();

  function frequencyKey(freq) {
    return (freq && freq.name ? freq.name : "").trim().toLowerCase();
  }

  function findFrequencyByName(exactName) {
    return FREQUENCIES.find(function (f) { return frequencyKey(f) === exactName; }) || null;
  }

  function isQuarterlyFrequency() {
    return !!(state.frequency && frequencyKey(state.frequency) === "tous les 3 mois");
  }

  // Libellé court pour les pastilles : "2 semaines", "6 semaines", "2 mois"…
  function shortFrequencyLabel(name) {
    var lower = (name || "").toLowerCase();
    var match = lower.match(/(\d+)/);
    var n = match ? parseInt(match[1], 10) : 1;
    if (lower.indexOf("semaine") !== -1) return n + (n > 1 ? " semaines" : " semaine");
    if (lower.indexOf("mois") !== -1) return n + " mois";
    return (name || "").trim();
  }

  function buildOtherFrequencies() {
    return FREQUENCIES
      .filter(function (f) { return MAIN_FREQUENCY_NAMES.indexOf(frequencyKey(f)) === -1; })
      .sort(function (a, b) { return parseFrequencyDays(a.name) - parseFrequencyDays(b.name); });
  }

  // La recommandation s'adapte à la consommation déclarée : à partir de 3 tasses/jour,
  // le volume nécessaire justifie naturellement le trimestriel (moins de réassorts,
  // les sachets sont consommés vite donc pas de perte de fraîcheur). En dessous,
  // le mensuel garde des sachets plus frais et un engagement plus léger.
  function recommendedFrequencyIsQuarterly() {
    return state.cupsPerDay >= 3;
  }

  function buildFrequencyOptions() {
    var monthly = findFrequencyByName("tous les mois");
    var quarterly = findFrequencyByName("tous les 3 mois");
    var options = [];
    if (monthly) options.push({ freq: monthly, label: "Mensuel", sub: "Recevez du café chaque mois" });
    if (quarterly) options.push({ freq: quarterly, label: "Trimestriel", sub: "Recevez du café tous les 3 mois" });
    return options;
  }

  function selectFrequency(freq) {
    state.frequency = freq;
    renderQuantity(); // recalcule la cible de poids et re-rend cartes + pastilles
    updateSummary();
    clearNavError();
  }

  function renderOtherFrequencies() {
    var others = buildOtherFrequencies();
    freqMoreEl.innerHTML = "";
    if (!others.length) {
      freqMoreEl.hidden = true;
      return;
    }
    freqMoreEl.hidden = false;

    var label = document.createElement("p");
    label.className = "wiz__freq-more-label";
    label.textContent = "Besoin d’un autre rythme ? Livraison toutes les :";
    freqMoreEl.appendChild(label);

    var pills = document.createElement("div");
    pills.className = "wiz__freq-more-pills";
    pills.setAttribute("role", "group");
    pills.setAttribute("aria-label", "Autres fréquences de livraison");

    var selectedOther = null;
    others.forEach(function (freq) {
      var isSelected = !!(state.frequency && state.frequency.name === freq.name);
      if (isSelected) selectedOther = freq;
      var btn = document.createElement("button");
      btn.type = "button";
      btn.className = "wiz__freq-pill" + (isSelected ? " is-selected" : "");
      btn.setAttribute("aria-pressed", isSelected ? "true" : "false");
      btn.textContent = shortFrequencyLabel(freq.name);
      btn.addEventListener("click", function () { selectFrequency(freq); });
      pills.appendChild(btn);
    });
    freqMoreEl.appendChild(pills);

    if (selectedOther) {
      var note = document.createElement("p");
      note.className = "wiz__freq-more-note";
      note.textContent =
        "≈ " + formatGrams(computeCardWeight(selectedOther.name)) + " / livraison" +
        (selectedOther.adjustmentValue ? " · même remise de -" + selectedOther.adjustmentValue + " %" : "") +
        " · pause ou annulation à tout moment";
      freqMoreEl.appendChild(note);
    }
  }

  function renderFrequencies() {
    freqGrid.innerHTML = "";
    var options = buildFrequencyOptions();

    if (!options.length && !buildOtherFrequencies().length) {
      freqGrid.innerHTML = '<p class="wiz__empty">Aucune fréquence d’abonnement n’est configurée sur vos produits café pour le moment.</p>';
      freqMoreEl.hidden = true;
      return;
    }

    options.forEach(function (opt) {
      var freq = opt.freq;
      var isQuarterly = frequencyKey(freq) === "tous les 3 mois";
      var isRecommended = options.length > 1 && isQuarterly === recommendedFrequencyIsQuarterly();
      var isSelected = !!(state.frequency && state.frequency.name === freq.name);
      var card = document.createElement("div");
      card.className = "wiz__freq-card" + (isRecommended ? " wiz__freq-card--recommended" : "") + (isSelected ? " is-selected" : "");
      card.setAttribute("role", "button");
      card.setAttribute("tabindex", "0");
      var ribbon = isRecommended ? '<span class="wiz__freq-ribbon">★ Recommandé pour vous</span>' : "";
      // La remise (réelle, ex. 5%) est la même pour toutes les fréquences : on l'affiche
      // sur les deux cartes, et on ajoute un argument pratique / écologique pour le trimestriel,
      // sans laisser croire à une remise additionnelle.
      var badge = freq.adjustmentValue ? '<span class="wiz__freq-badge">-' + freq.adjustmentValue + "% dto</span>" : "";
      var ecoNote = isQuarterly ? '<span class="wiz__freq-eco">♻️ 3× moins de livraisons, meilleur bilan carbone</span>' : "";
      var weightGrams = computeCardWeight(freq.name);
      var minimumGrams = isQuarterly ? QUARTERLY_MIN_GRAMS : 500;
      var minimumLabel = isQuarterly ? "trimestre" : "mois";
      card.innerHTML =
        ribbon +
        '<div class="wiz__freq-card-inner">' +
        '<span class="wiz__freq-name">' + escapeHtml(opt.label) + "</span>" +
        '<span class="wiz__freq-sub">' + escapeHtml(opt.sub) + "</span>" +
        '<span class="wiz__freq-divider"></span>' +
        '<span class="wiz__freq-icon-wrap"><span class="wiz__freq-icon" aria-hidden="true">' + FREQ_ICON + "</span>" + badge + "</span>" +
        '<span class="wiz__freq-weight">' + formatGrams(weightGrams) + " / livraison</span>" +
        ecoNote +
        '<button type="button" class="wiz__freq-btn">' + (isSelected ? "Sélectionné ✓" : "Choisir cette formule") + "</button>" +
        '<span class="wiz__freq-minimum">Minimum ' + formatGrams(minimumGrams) + " / " + minimumLabel + ". Pause ou annulation à tout moment.</span>" +
        "</div>";
      card.addEventListener("click", function () { selectFrequency(freq); });
      card.addEventListener("keydown", function (e) {
        if (e.key === "Enter" || e.key === " ") { e.preventDefault(); card.click(); }
      });
      freqGrid.appendChild(card);
    });

    renderOtherFrequencies();
  }

  // ---------- Step 4: weight progress (poids calculé automatiquement, comme Incapto) ----------
  var weightProgressEl = root.querySelector("[data-weight-progress]");
  var weightTargetEl = root.querySelector("[data-weight-target]");
  var weightCurrentEl = root.querySelector("[data-weight-current]");
  var weightFillEl = root.querySelector("[data-weight-fill]");

  function formatGrams(grams) {
    if (grams >= 1000) {
      var kg = grams / 1000;
      var rounded = Math.round(kg * 10) / 10;
      return rounded.toLocaleString("fr-BE", { minimumFractionDigits: rounded % 1 === 0 ? 0 : 1, maximumFractionDigits: 1 }) + " kg";
    }
    return grams + " g";
  }

  function currentSelectedGrams() {
    var total = 0;
    Object.keys(state.coffees).forEach(function (id) {
      var sel = state.coffees[id];
      var variant = (sel.product.variants || []).find(function (v) { return v.id === sel.variantId; });
      var unitWeight = variant ? variantWeightGrams(sel.product, variant) : (sel.product.weightGrams || 500);
      total += unitWeight * sel.qty;
    });
    return total;
  }

  function variantWeightGrams(product, variant) {
    var token = (variant.title || "").trim().split(/\s+/)[0];
    var grams = parseInt(token, 10);
    if (!grams || isNaN(grams)) return product.weightGrams || 500;
    return grams;
  }

  function variantGrindLabel(variant) {
    var parts = (variant.title || "").split("/");
    return parts.length > 1 ? parts[1].trim() : "";
  }

  function grindShortLabel(grind) {
    var prefix = "Moulu cafetière ";
    if (!grind) return "";
    if (grind.indexOf(prefix) === 0) return "Moulu · " + grind.slice(prefix.length);
    return grind;
  }

  var GRIND_ICONS = {
    "en-grain": '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><ellipse cx="12" cy="12" rx="6.4" ry="8.8" transform="rotate(24 12 12)"/><path d="M12 4.3c-2 2.8-2 10.6 0 15.4" transform="rotate(24 12 12)"/></svg>',
    "piston": '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="6.3" y="7.5" width="9.4" height="12.5" rx="1.6"/><path d="M15.7 10.2c2 .1 3 1 3 2.5s-1 2.4-3 2.5"/><path d="M11 3.4v4.1"/><circle cx="11" cy="2.6" r="1" fill="currentColor" stroke="none"/><path d="M6.3 12.6h9.4"/></svg>',
    "expresso": '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M8 8h8v3.2a4 4 0 0 1-8 0z"/><path d="M16 9h2.5c1 0 1 1.4 0 1.4H16"/><path d="M10 12.5v3.5M14 12.5v3.5"/></svg>',
    "filtre": '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M6.4 6.4h11.2l-4.8 8.4h-1.6L6.4 6.4z"/><path d="M12 15.6v2.6"/><circle cx="12" cy="19.4" r="1" fill="currentColor" stroke="none"/></svg>',
    "italienne": '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M12 3.5c-1.3 0-2.3 1-2.1 2.3l.4 2.7-1.3 2v2.2l-1 5.3c-.1.7.4 1.3 1.1 1.3h6c.7 0 1.2-.6 1.1-1.3l-1-5.3v-2.2l-1.3-2 .4-2.7c.2-1.3-.8-2.3-2.1-2.3z"/><path d="M15.3 9.5c1.6 0 2.4.7 2.4 1.8s-.8 1.8-2.4 1.8"/></svg>',
    "turc": '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M8.6 18h6.8l-.5-5a3.4 3.4 0 0 0-2.9-3h-.1a3.4 3.4 0 0 0-2.9 3l-.4 5z"/><path d="M10.6 10c-.3-1.3.4-2.3 1.4-2.3s1.7 1 1.4 2.3"/><path d="M14.8 12.5h6"/></svg>'
  };

  function grindIconSvg(grind) {
    var g = (grind || "").toLowerCase();
    if (g.indexOf("piston") !== -1) return GRIND_ICONS["piston"];
    if (g.indexOf("expresso") !== -1 || g.indexOf("espresso") !== -1) return GRIND_ICONS["expresso"];
    if (g.indexOf("filtre") !== -1) return GRIND_ICONS["filtre"];
    if (g.indexOf("italienne") !== -1) return GRIND_ICONS["italienne"];
    if (g.indexOf("turc") !== -1) return GRIND_ICONS["turc"];
    if (g.indexOf("grain") !== -1) return GRIND_ICONS["en-grain"];
    return "";
  }

  function discountedPrice(price) {
    var discountPct = state.frequency ? Number(state.frequency.adjustmentValue) || 0 : 0;
    return discountPct ? Math.round(price * (1 - discountPct / 100)) : price;
  }

  function renderWeightProgress() {
    if (!weightProgressEl) return;
    if (!state.targetGrams) {
      weightProgressEl.hidden = true;
      return;
    }
    weightProgressEl.hidden = false;
    var current = currentSelectedGrams();
    var isComplete = state.targetGrams > 0 && current >= state.targetGrams;
    weightTargetEl.textContent = formatGrams(state.targetGrams);
    weightCurrentEl.textContent = isComplete ? "Done !" : formatGrams(current) + " sélectionné" + (current >= 1000 ? "s" : "");
    var pct = state.targetGrams ? Math.min(100, Math.round((current / state.targetGrams) * 100)) : 0;
    weightFillEl.style.width = pct + "%";
    weightFillEl.classList.toggle("is-complete", isComplete);
    weightCurrentEl.classList.toggle("is-complete", isComplete);
    weightProgressEl.classList.toggle("is-complete", isComplete);
  }

  // ---------- Step 4: coffee ----------
  var coffeeGrid = root.querySelector('[data-grid="coffees"]');

  function buildCoffeePricingHtml(product) {
    var unitPrice = product.price;
    var discountPct = state.frequency ? Number(state.frequency.adjustmentValue) || 0 : 0;
    var subPrice = discountPct ? Math.round(unitPrice * (1 - discountPct / 100)) : unitPrice;
    var weight = product.weightGrams || 500;
    var pricePerCup = Math.round((subPrice / weight) * GRAMS_PER_CUP_PER_DAY);

    var html = '<div class="wiz__card-price-hero"><strong class="wiz__card-price-hero-value">' + money(pricePerCup) + '</strong><span class="wiz__card-price-hero-label">/ tasse</span></div>';
    html += '<div class="wiz__card-price-row">';
    if (discountPct) {
      html += '<span class="wiz__card-price-original">' + money(unitPrice) + "</span>";
    }
    html += '<span class="wiz__card-price-sub">' + money(subPrice) + "</span>";
    html += '<span class="wiz__card-price-label">' + (discountPct ? "/ sachet, abonnement" : "/ sachet") + "</span>";
    html += "</div>";
    return html;
  }

  function renderCoffees(mode) {
    var list = sortProducts(DATA.coffees, mode || "featured");
    renderProductGrid(coffeeGrid, list, {
      renderCard: function (product) {
        var selection = state.coffees[product.id];
        var qty = selection ? selection.qty : 0;
        var card = document.createElement("div");
        card.className = "wiz__card";
        if (qty > 0) card.classList.add("is-selected");
        var selectedVariant = selection ? (product.variants || []).find(function (v) { return v.id === selection.variantId; }) : null;
        var selectedWeightLabel = selectedVariant ? formatGrams(variantWeightGrams(product, selectedVariant)) : "";
        var selectedGrindLabel = selectedVariant ? grindShortLabel(variantGrindLabel(selectedVariant)) : "";
        var btnLabel = qty > 0 ? "Modifier — " + qty + " × " + selectedWeightLabel + (selectedGrindLabel ? " (" + selectedGrindLabel + ")" : "") : "Choisir";
        card.innerHTML =
          '<div class="wiz__card-media"><span class="wiz__badge wiz__badge--recurring">Abonnement</span><img src="' + product.image + '" alt="' + escapeHtml(product.title) + '" loading="lazy"></div>' +
          '<div class="wiz__card-body">' +
          '<span class="wiz__card-grind">' + escapeHtml(product.grindType || "Café") + "</span>" +
          '<h3 class="wiz__card-title">' + escapeHtml(product.title) + "</h3>" +
          '<p class="wiz__card-tagline">' + escapeHtml(product.tagline || "") + "</p>" +
          '<div class="wiz__card-pricing">' + buildCoffeePricingHtml(product) + "</div>" +
          '<button type="button" class="wiz__btn wiz__btn--select" data-open-modal>' + escapeHtml(btnLabel) + "</button>" +
          "</div>";
        card.querySelector("[data-open-modal]").addEventListener("click", function () {
          openProductModal(product);
        });
        return card;
      },
    });
  }

  function setCoffeeQty(product, qty, variantId) {
    if (qty <= 0) {
      delete state.coffees[product.id];
    } else {
      var vId = variantId || product.defaultVariantId || (product.variants[0] && product.variants[0].id);
      state.coffees[product.id] = { product: product, variantId: vId, qty: qty };
    }
    updateSummary();
    renderWeightProgress();
    clearNavError();
  }

  // ---------- Step 4: product detail modal (choix du poids / quantité, comme Incapto) ----------
  var productOverlay = root.querySelector("[data-product-overlay]");
  var productModal = root.querySelector("[data-product-modal]");
  var modalImageEl = root.querySelector("[data-product-modal-image]");
  var modalGrindEl = root.querySelector("[data-product-modal-grind]");
  var modalTitleEl = root.querySelector("[data-product-modal-title]");
  var modalTaglineEl = root.querySelector("[data-product-modal-tagline]");
  var modalPriceEl = root.querySelector("[data-product-modal-price]");
  var modalSummaryEl = root.querySelector("[data-product-modal-summary]");
  var modalVariantsEl = root.querySelector("[data-product-modal-variants]");
  var modalGrindsEl = root.querySelector("[data-product-modal-grinds]");
  var modalSelectBtn = root.querySelector("[data-product-modal-select]");
  var modalRemoveBtn = root.querySelector("[data-product-modal-remove]");
  var modalCloseBtns = root.querySelectorAll("[data-product-modal-close]");

  var modalState = null; // { product, grind, variantId, qty }

  function modalDistinctGrinds() {
    var product = modalState.product;
    var seen = {};
    var list = [];
    (product.variants || []).forEach(function (v) {
      var g = variantGrindLabel(v);
      if (g && !seen[g]) {
        seen[g] = true;
        list.push(g);
      }
    });
    return list;
  }

  function modalVariantList() {
    var product = modalState.product;
    if (!product.variants || !product.variants.length) {
      return [{ id: product.defaultVariantId, title: (product.weightGrams || 500) + " gr", price: product.price }];
    }
    if (!modalState.grind) return product.variants;
    var filtered = product.variants.filter(function (v) { return variantGrindLabel(v) === modalState.grind; });
    return filtered.length ? filtered : product.variants;
  }

  function renderModalGrinds() {
    if (!modalGrindsEl) return;
    var grinds = modalDistinctGrinds();
    if (modalGrindEl) modalGrindEl.textContent = grindShortLabel(modalState.grind) || modalState.product.grindType || "Café";
    if (grinds.length <= 1) {
      modalGrindsEl.hidden = true;
      modalGrindsEl.innerHTML = "";
      return;
    }
    modalGrindsEl.hidden = false;
    modalGrindsEl.innerHTML = '<span class="wiz__grind-picker-label">Mouture</span>';
    var pillsWrap = document.createElement("div");
    pillsWrap.className = "wiz__grind-pills";
    grinds.forEach(function (g) {
      var btn = document.createElement("button");
      btn.type = "button";
      btn.className = "wiz__grind-pill" + (modalState.grind === g ? " is-selected" : "");
      btn.innerHTML = grindIconSvg(g) + "<span>" + escapeHtml(grindShortLabel(g)) + "</span>";
      btn.addEventListener("click", function () { selectModalGrind(g); });
      pillsWrap.appendChild(btn);
    });
    modalGrindsEl.appendChild(pillsWrap);
  }

  function selectModalGrind(grind) {
    if (!modalState || modalState.grind === grind) return;
    var prevVariant = getModalSelectedVariant();
    var prevWeight = prevVariant ? variantWeightGrams(modalState.product, prevVariant) : null;
    modalState.grind = grind;
    var candidates = modalVariantList();
    var match = prevWeight ? candidates.find(function (v) { return variantWeightGrams(modalState.product, v) === prevWeight; }) : null;
    var target = match || candidates[0];
    modalState.variantId = target.id;
    renderModalGrinds();
    renderModalVariants();
    renderModalSummary();
  }

  function getModalSelectedVariant() {
    if (!modalState) return null;
    var variants = modalVariantList();
    return variants.find(function (v) { return v.id === modalState.variantId; }) || variants[0];
  }

  function selectModalVariant(variantId) {
    if (!modalState || modalState.variantId === variantId) return;
    modalState.variantId = variantId;
    renderModalVariants();
    renderModalSummary();
  }

  function renderModalVariants() {
    if (!modalState) return;
    modalVariantsEl.innerHTML = "";
    var product = modalState.product;
    var discountPct = state.frequency ? Number(state.frequency.adjustmentValue) || 0 : 0;
    modalVariantList().forEach(function (variant) {
      var weight = variantWeightGrams(product, variant);
      var subPrice = discountedPrice(variant.price);
      var cups = Math.max(1, Math.round(weight / GRAMS_PER_CUP_PER_DAY));
      var isSelected = modalState.variantId === variant.id;
      var row = document.createElement("div");
      row.className = "wiz__variant-row" + (isSelected ? " is-selected" : "");
      row.innerHTML =
        '<span class="wiz__variant-radio" aria-hidden="true"></span>' +
        '<span class="wiz__variant-weight">' + formatGrams(weight) + "</span>" +
        '<span class="wiz__variant-price">' +
        (discountPct ? '<span class="orig">' + money(variant.price) + "</span>" : "") +
        "<strong>" + money(subPrice) + "</strong> / sachet" +
        "</span>" +
        '<span class="wiz__variant-cups">' + cups + " tasses</span>" +
        '<div class="wiz__variant-stepper" data-variant-stepper>' +
        '<button type="button" data-dec>−</button>' +
        '<span data-qty>' + (isSelected ? modalState.qty : 1) + "</span>" +
        '<button type="button" data-inc>+</button>' +
        "</div>";
      row.addEventListener("click", function (e) {
        if (e.target.closest("[data-variant-stepper]")) return;
        selectModalVariant(variant.id);
      });
      row.querySelector("[data-inc]").addEventListener("click", function (e) {
        e.stopPropagation();
        var wasSelected = modalState.variantId === variant.id;
        modalState.variantId = variant.id;
        modalState.qty = Math.min(20, (wasSelected ? modalState.qty : 1) + 1);
        renderModalVariants();
        renderModalSummary();
      });
      row.querySelector("[data-dec]").addEventListener("click", function (e) {
        e.stopPropagation();
        var wasSelected = modalState.variantId === variant.id;
        modalState.variantId = variant.id;
        modalState.qty = Math.max(1, (wasSelected ? modalState.qty : 1) - 1);
        renderModalVariants();
        renderModalSummary();
      });
      modalVariantsEl.appendChild(row);
    });
  }

  function renderModalSummary() {
    if (!modalState) return;
    var variant = getModalSelectedVariant();
    var weight = variantWeightGrams(modalState.product, variant);
    var totalWeight = weight * modalState.qty;
    var cups = Math.max(1, Math.round(totalWeight / GRAMS_PER_CUP_PER_DAY));
    modalSummaryEl.textContent = "Quantité : " + formatGrams(totalWeight) + " · " + cups + " tasses";

    var subPrice = discountedPrice(variant.price);
    var discountPct = state.frequency ? Number(state.frequency.adjustmentValue) || 0 : 0;
    var pricePerCup = Math.round((subPrice / weight) * GRAMS_PER_CUP_PER_DAY);
    var pricePerKg = Math.round(subPrice / (weight / 1000));
    modalPriceEl.innerHTML =
      (discountPct ? '<span class="original">' + money(variant.price) + "</span>" : "") +
      '<span class="current">' + money(subPrice) + "</span>" +
      '<span class="meta">Soit ' + money(pricePerCup) + " / tasse · " + money(pricePerKg) + " / kg</span>";
  }

  function openProductModal(product) {
    var existing = state.coffees[product.id];
    var initialVariantId = existing ? existing.variantId : (product.defaultVariantId || (product.variants[0] && product.variants[0].id));
    var initialVariant = (product.variants || []).find(function (v) { return v.id === initialVariantId; });
    var initialGrind = initialVariant ? variantGrindLabel(initialVariant) : ((product.variants && product.variants[0]) ? variantGrindLabel(product.variants[0]) : "");
    modalState = {
      product: product,
      grind: initialGrind,
      variantId: initialVariantId,
      qty: existing ? existing.qty : 1,
    };
    modalImageEl.src = product.image;
    modalImageEl.alt = product.title;
    modalTitleEl.textContent = product.title;
    modalTaglineEl.textContent = product.tagline || "";
    renderModalGrinds();
    renderModalVariants();
    renderModalSummary();
    if (modalRemoveBtn) modalRemoveBtn.hidden = !existing;

    productModal.hidden = false;
    productModal.setAttribute("aria-hidden", "false");
    if (productOverlay) productOverlay.hidden = false;
    document.body.style.overflow = "hidden";
  }

  function closeProductModal() {
    if (!productModal) return;
    productModal.hidden = true;
    productModal.setAttribute("aria-hidden", "true");
    if (productOverlay) productOverlay.hidden = true;
    document.body.style.overflow = "";
    modalState = null;
  }

  modalCloseBtns.forEach(function (btn) { btn.addEventListener("click", closeProductModal); });
  if (productOverlay) productOverlay.addEventListener("click", closeProductModal);
  if (modalSelectBtn) {
    modalSelectBtn.addEventListener("click", function () {
      if (!modalState) return;
      setCoffeeQty(modalState.product, modalState.qty, modalState.variantId);
      renderCoffees(currentSort("coffees"));
      closeProductModal();
    });
  }
  if (modalRemoveBtn) {
    modalRemoveBtn.addEventListener("click", function () {
      if (!modalState) return;
      setCoffeeQty(modalState.product, 0);
      renderCoffees(currentSort("coffees"));
      closeProductModal();
    });
  }

  // ---------- Step 5: accessories ----------
  var accGrid = root.querySelector('[data-grid="accessories"]');
  function renderAccessories(mode) {
    var list = sortProducts(DATA.accessories, mode || "featured");
    renderProductGrid(accGrid, list, {
      renderCard: function (product) {
        var selection = state.accessories[product.id];
        var qty = selection ? selection.qty : 0;
        var card = document.createElement("div");
        card.className = "wiz__card";
        if (qty > 0) card.classList.add("is-selected");
        card.innerHTML =
          '<div class="wiz__card-media"><span class="wiz__badge wiz__badge--onetime">Achat unique</span><img src="' + product.image + '" alt="' + escapeHtml(product.title) + '" loading="lazy"></div>' +
          '<div class="wiz__card-body">' +
          '<h3 class="wiz__card-title">' + escapeHtml(product.title) + "</h3>" +
          '<p class="wiz__card-price">' + money(product.price) + "</p>" +
          '<div class="wiz__stepper">' +
          '<button type="button" class="wiz__stepper-btn" data-dec>−</button>' +
          '<span class="wiz__stepper-qty">' + qty + "</span>" +
          '<button type="button" class="wiz__stepper-btn" data-inc>+</button>' +
          "</div>" +
          "</div>";
        card.querySelector("[data-inc]").addEventListener("click", function () {
          setAccessoryQty(product, qty + 1);
          renderAccessories(currentSort("accessories"));
        });
        card.querySelector("[data-dec]").addEventListener("click", function () {
          setAccessoryQty(product, Math.max(0, qty - 1));
          renderAccessories(currentSort("accessories"));
        });
        return card;
      },
    });
  }

  function setAccessoryQty(product, qty) {
    if (qty <= 0) {
      delete state.accessories[product.id];
    } else {
      state.accessories[product.id] = { product: product, qty: qty };
    }
    updateSummary();
  }

  // ---------- Sorting toolbar ----------
  root.querySelectorAll("[data-sort]").forEach(function (select) {
    select.addEventListener("change", function () {
      var target = select.getAttribute("data-sort");
      if (target === "machines") renderMachines(select.value);
      if (target === "coffees") renderCoffees(select.value);
    });
  });
  function currentSort(target) {
    var select = root.querySelector('[data-sort="' + target + '"]');
    return select ? select.value : "featured";
  }

  // ---------- Order summary ----------
  var linesEl = root.querySelector("[data-order-lines]");
  var totalEl = root.querySelector("[data-order-total]");
  var discountRow = root.querySelector("[data-order-discount-row]");
  var discountEl = root.querySelector("[data-order-discount]");
  var shippingEl = root.querySelector("[data-order-shipping]");
  var FREE_SHIPPING_THRESHOLD = 3900; // 39,00 €

  function computeOrder() {
    var lines = [];
    var subtotal = 0;
    var discount = 0;

    if (state.machine) {
      var machineVariant = (state.machine.product.variants || []).find(function (v) { return v.id === state.machine.variantId; });
      var machinePrice = machineVariant ? machineVariant.price : state.machine.product.price;
      var machineHasOptions = (state.machine.product.variants || []).length > 1;
      var machineLabel = state.machine.product.title + (machineHasOptions && machineVariant ? " (" + machineVariant.title + ")" : "");
      subtotal += machinePrice;
      lines.push({
        label: machineLabel,
        amount: machinePrice,
        remove: function () {
          state.machine = null;
          renderMachines(currentSort("machines"));
          updateSummary();
          clearNavError();
        },
      });
    }

    Object.keys(state.coffees).forEach(function (id) {
      var sel = state.coffees[id];
      var variant = (sel.product.variants || []).find(function (v) { return v.id === sel.variantId; });
      var unitPrice = variant ? variant.price : sel.product.price;
      var lineTotal = unitPrice * sel.qty;
      subtotal += lineTotal;
      var plan = state.frequency ? findSellingPlanForProduct(sel.product, state.frequency.name) : null;
      if (plan && plan.adjustmentType === "percentage") {
        discount += lineTotal * (plan.adjustmentValue / 100);
      }
      var weightLabel = variant ? formatGrams(variantWeightGrams(sel.product, variant)) : "";
      var grindLabel = variant ? grindShortLabel(variantGrindLabel(variant)) : "";
      var lineDetail = [weightLabel, grindLabel].filter(Boolean).join(", ");
      lines.push({
        label: sel.product.title + (lineDetail ? " (" + lineDetail + ")" : "") + " ×" + sel.qty,
        amount: lineTotal,
        remove: function () {
          delete state.coffees[id];
          renderCoffees(currentSort("coffees"));
          renderWeightProgress();
          updateSummary();
          clearNavError();
        },
      });
    });

    Object.keys(state.accessories).forEach(function (id) {
      var sel = state.accessories[id];
      var lineTotal = sel.product.price * sel.qty;
      subtotal += lineTotal;
      lines.push({
        label: sel.product.title + " ×" + sel.qty,
        amount: lineTotal,
        remove: function () {
          delete state.accessories[id];
          renderAccessories(currentSort("accessories"));
          updateSummary();
          clearNavError();
        },
      });
    });

    return { lines: lines, subtotal: subtotal, discount: discount, total: subtotal - discount };
  }

  // Small "✕" button used to remove a line from the order summary (sidebar and step 6 recap).
  function buildLineRemoveButton(line) {
    var btn = document.createElement("button");
    btn.type = "button";
    btn.className = "wiz__line-remove";
    btn.setAttribute("aria-label", "Retirer " + line.label + " de la commande");
    btn.textContent = "✕";
    btn.addEventListener("click", function (e) {
      e.preventDefault();
      e.stopPropagation();
      line.remove();
    });
    return btn;
  }

  function updateSummary() {
    var order = computeOrder();
    linesEl.innerHTML = "";
    order.lines.forEach(function (line) {
      var dt = document.createElement("dt");
      dt.textContent = line.label;
      var dd = document.createElement("dd");
      var priceSpan = document.createElement("span");
      priceSpan.textContent = money(line.amount);
      dd.appendChild(priceSpan);
      if (line.remove) dd.appendChild(buildLineRemoveButton(line));
      linesEl.appendChild(dt);
      linesEl.appendChild(dd);
    });
    if (order.discount > 0) {
      discountRow.hidden = false;
      discountEl.textContent = "−" + money(order.discount);
    } else {
      discountRow.hidden = true;
    }
    totalEl.textContent = money(order.total);
    if (shippingEl) {
      var remaining = FREE_SHIPPING_THRESHOLD - order.total;
      if (remaining > 0) {
        shippingEl.textContent = "Encore " + money(remaining) + " pour la gratuité";
        shippingEl.classList.add("is-pending");
      } else {
        shippingEl.textContent = "Gratuite ✓";
        shippingEl.classList.remove("is-pending");
      }
    }
    renderFinalSummary(order);
  }

  function renderFinalSummary(order) {
    var el = root.querySelector("[data-summary-detail]");
    if (!el) return;
    if (!order.lines.length) {
      el.innerHTML = '<p class="wiz__empty">Aucun article sélectionné pour le moment.</p>';
      return;
    }
    el.innerHTML = "";
    var ul = document.createElement("ul");
    ul.className = "wiz__final-lines";
    order.lines.forEach(function (line) {
      var li = document.createElement("li");
      var labelSpan = document.createElement("span");
      labelSpan.textContent = line.label;
      var right = document.createElement("div");
      right.className = "wiz__final-line-right";
      var priceStrong = document.createElement("strong");
      priceStrong.textContent = money(line.amount);
      right.appendChild(priceStrong);
      if (line.remove) right.appendChild(buildLineRemoveButton(line));
      li.appendChild(labelSpan);
      li.appendChild(right);
      ul.appendChild(li);
    });
    el.appendChild(ul);
    if (state.frequency) {
      var freqP = document.createElement("p");
      freqP.className = "wiz__final-freq";
      freqP.innerHTML = "Fréquence choisie : <strong>" + escapeHtml(state.frequency.name.trim()) + "</strong>";
      el.appendChild(freqP);
    }
  }

  // ---------- Navigation ----------
  var panels = Array.prototype.slice.call(root.querySelectorAll("[data-panel]"));
  var dots = Array.prototype.slice.call(root.querySelectorAll("[data-step-dot]"));
  var prevBtn = root.querySelector("[data-prev]");
  var nextBtn = root.querySelector("[data-next]");
  var addToCartBtn = root.querySelector("[data-add-to-cart]");
  var navError = root.querySelector("[data-nav-error]");
  var bodyEl = root.querySelector(".wiz__body");
  var navEl = root.querySelector(".wiz__nav");
  var progressEl = root.querySelector(".wiz__progress");

  function stepSequence() {
    // Skip step 2 (machine) if the customer chose "coffee-only"
    if (state.planType === "coffee-only") return [1, 3, 4, 5, 6];
    return [1, 2, 3, 4, 5, 6];
  }

  function goToStep(step) {
    state.step = step;
    panels.forEach(function (panel) {
      panel.classList.toggle("is-active", Number(panel.getAttribute("data-panel")) === step);
    });
    dots.forEach(function (dot) {
      var n = Number(dot.getAttribute("data-step-dot"));
      dot.classList.toggle("is-active", n === step);
      dot.classList.toggle("is-done", stepSequence().indexOf(n) < stepSequence().indexOf(step));
      dot.classList.toggle("is-skipped", n === 2 && state.planType === "coffee-only");
    });
    var seq = stepSequence();
    prevBtn.style.visibility = seq[0] === step ? "hidden" : "visible";
    var isLast = seq[seq.length - 1] === step;
    nextBtn.hidden = isLast;
    addToCartBtn.hidden = !isLast;
    if (navEl) navEl.hidden = step === 1;
    if (progressEl) progressEl.hidden = step === 1;
    if (bodyEl) bodyEl.classList.toggle("wiz__body--full", step === 1 || step === 2 || step === 3 || step === 4 || step === 5);
    if (step === 4) renderCoffees(currentSort("coffees"));
    clearNavError();
    root.scrollIntoView({ behavior: "smooth", block: "start" });
  }

  function validateStep(step) {
    if (step === 1 && !state.planType) return "Choisissez une formule pour continuer.";
    if (step === 2 && state.planType === "machine-coffee" && !state.machine) return "Choisissez une machine pour continuer.";
    if (step === 3 && !state.frequency) return "Sélectionnez une fréquence de livraison.";
    if (step === 4 && Object.keys(state.coffees).length === 0) return "Choisissez au moins un café.";
    if (step === 4 && isQuarterlyFrequency() && currentSelectedGrams() < QUARTERLY_MIN_GRAMS) {
      var missingGrams = QUARTERLY_MIN_GRAMS - currentSelectedGrams();
      return "La remise trimestrielle nécessite un minimum de 1 kg de café. Ajoutez encore " + formatGrams(missingGrams) + ".";
    }
    return null;
  }

  function showNavError(message) {
    navError.textContent = message;
    navError.hidden = false;
  }
  function clearNavError() {
    navError.hidden = true;
    navError.textContent = "";
  }

  nextBtn.addEventListener("click", function () {
    var error = validateStep(state.step);
    if (error) { showNavError(error); return; }
    var seq = stepSequence();
    var idx = seq.indexOf(state.step);
    if (idx < seq.length - 1) goToStep(seq[idx + 1]);
  });

  prevBtn.addEventListener("click", function () {
    var seq = stepSequence();
    var idx = seq.indexOf(state.step);
    if (idx > 0) goToStep(seq[idx - 1]);
  });

  root.querySelectorAll("[data-plan-choice]").forEach(function (btn) {
    btn.addEventListener("click", function () {
      state.planType = btn.getAttribute("data-plan-choice");
      root.querySelectorAll("[data-plan-choice]").forEach(function (b) {
        b.classList.toggle("is-selected", b === btn);
      });
      var error = validateStep(1);
      if (!error) {
        var seq = stepSequence();
        goToStep(seq[1]);
      }
    });
    btn.addEventListener("keydown", function (e) {
      if (e.key === "Enter" || e.key === " ") { e.preventDefault(); btn.click(); }
    });
  });

  // ---------- Add to cart ----------
  addToCartBtn.addEventListener("click", function () {
    if (state.submitted) return;

    if (Object.keys(state.coffees).length === 0) {
      showNavError("Choisissez au moins un café pour continuer.");
      return;
    }

    if (isQuarterlyFrequency() && currentSelectedGrams() < QUARTERLY_MIN_GRAMS) {
      showNavError("La remise trimestrielle nécessite un minimum de 1 kg de café. Ajoutez encore " + formatGrams(QUARTERLY_MIN_GRAMS - currentSelectedGrams()) + ".");
      return;
    }

    var order = computeOrder();
    var missing = FREE_SHIPPING_THRESHOLD - order.total;
    if (missing > 0) {
      showNavError("Ajoutez encore " + money(missing) + " pour atteindre le minimum de " + money(FREE_SHIPPING_THRESHOLD) + " (livraison gratuite).");
      return;
    }

    var items = [];

    if (state.machine) {
      items.push({ id: state.machine.variantId, quantity: 1 });
    }

    Object.keys(state.coffees).forEach(function (id) {
      var sel = state.coffees[id];
      var plan = state.frequency ? findSellingPlanForProduct(sel.product, state.frequency.name) : null;
      var item = { id: sel.variantId, quantity: sel.qty };
      if (plan) item.selling_plan = plan.id;
      items.push(item);
    });

    Object.keys(state.accessories).forEach(function (id) {
      var sel = state.accessories[id];
      items.push({ id: sel.product.variantId, quantity: sel.qty });
    });

    if (!items.length) {
      showNavError("Votre sélection est vide.");
      return;
    }

    addToCartBtn.disabled = true;
    addToCartBtn.textContent = "Redirection vers le paiement…";

    fetch(DATA.routes.cartAdd + ".js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ items: items }),
    })
      .then(function (res) {
        if (!res.ok) return res.json().then(function (err) { throw err; });
        return res.json();
      })
      .then(function () {
        state.submitted = true;
        // Le récapitulatif fait office de panier : on va directement au paiement
        // plutôt que d'ajouter une étape de confirmation intermédiaire.
        window.location.href = DATA.routes.checkout || "/checkout";
      })
      .catch(function (err) {
        console.error("Wizard add to cart error", err);
        showNavError((err && err.description) || "Une erreur est survenue, merci de réessayer.");
        addToCartBtn.disabled = false;
        addToCartBtn.textContent = "Passer au paiement →";
      });
  });

  root.querySelector("[data-restart]").addEventListener("click", function () {
    state = { step: 1, planType: null, machine: null, frequency: null, coffees: {}, accessories: {}, cupsPerDay: 2, targetGrams: null, submitted: false };
    root.querySelectorAll("[data-plan-choice]").forEach(function (b) { b.classList.remove("is-selected"); });
    addToCartBtn.disabled = false;
    addToCartBtn.textContent = "Passer au paiement →";
    root.querySelector("[data-confirmation]").hidden = true;
    renderMachines();
    renderQuantity();
    renderFrequencies();
    renderCoffees();
    renderAccessories();
    updateSummary();
    renderWeightProgress();
    goToStep(1);
  });

  function escapeHtml(str) {
    return String(str || "").replace(/[&<>"']/g, function (c) {
      return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c];
    });
  }

  // ---------- Contact panel ("Nous contacter" — rappel téléphonique + email) ----------
  var contactOpenBtns = root.querySelectorAll("[data-contact-open]");
  var contactPanel = root.querySelector("[data-contact-panel]");
  var contactOverlay = root.querySelector("[data-contact-overlay]");
  var contactCloseBtns = root.querySelectorAll("[data-contact-close]");

  function openContactPanel() {
    if (!contactPanel) return;
    contactPanel.hidden = false;
    contactPanel.setAttribute("aria-hidden", "false");
    if (contactOverlay) contactOverlay.hidden = false;
    document.body.style.overflow = "hidden";
  }
  function closeContactPanel() {
    if (!contactPanel) return;
    contactPanel.hidden = true;
    contactPanel.setAttribute("aria-hidden", "true");
    if (contactOverlay) contactOverlay.hidden = true;
    document.body.style.overflow = "";
  }
  contactOpenBtns.forEach(function (btn) {
    btn.addEventListener("click", openContactPanel);
  });
  contactCloseBtns.forEach(function (btn) {
    btn.addEventListener("click", closeContactPanel);
  });
  if (contactOverlay) contactOverlay.addEventListener("click", closeContactPanel);
  document.addEventListener("keydown", function (e) {
    if (e.key !== "Escape") return;
    if (contactPanel && !contactPanel.hidden) closeContactPanel();
    if (productModal && !productModal.hidden) closeProductModal();
    if (machineModal && !machineModal.hidden) closeMachineModal();
  });

  var contactForm = root.querySelector("#wizard-contact-form");
  if (contactForm) {
    contactForm.addEventListener("submit", function () {
      var countryEl = contactForm.querySelector("[data-contact-country]");
      var phoneEl = contactForm.querySelector("[data-contact-phone]");
      var contactBodyEl = contactForm.querySelector("[data-contact-body]");
      var phone = (countryEl ? countryEl.value : "") + " " + (phoneEl ? phoneEl.value : "");
      var client = contactForm.querySelector('input[name="q_client"]:checked');
      var slot = contactForm.querySelector('input[name="q_slot"]:checked');
      var type = contactForm.querySelector('input[name="q_type"]:checked');
      var lines = [
        "Demande de rappel depuis le wizard abonnement",
        "Téléphone : " + phone,
        "Déjà client : " + (client ? client.value : "—"),
        "Créneau souhaité : " + (slot ? slot.value : "—"),
        "Particulier / Entreprise : " + (type ? type.value : "—"),
      ];
      if (contactBodyEl) contactBodyEl.value = lines.join("\n");
    });
  }

  // ---------- Sticky header offset (so the progress bar sticks right below the theme header) ----------
  function updateHeaderOffset() {
    var header = root.querySelector(".wiz__topbar") || document.querySelector(".shopify-section-group-header-group, .header-sticky, header.header, header");
    var offset = 0;
    if (header) {
      var cs = getComputedStyle(header);
      if (cs.position === "sticky" || cs.position === "fixed") {
        offset = header.offsetHeight || 0;
      }
    }
    root.style.setProperty("--wiz-header-offset", offset + "px");
  }
  updateHeaderOffset();
  window.addEventListener("resize", updateHeaderOffset);

  // ---------- Init ----------
  renderMachines();
  renderQuantity();
  renderFrequencies();
  renderCoffees();
  renderAccessories();
  updateSummary();
  renderWeightProgress();
  goToStep(1);
})();
